import styled from 'styled-components';
import { secondaryFontColor } from 'Public/Css/colors';
import { Typography } from 'antd';

export default styled(Typography.Title) `

  &.ant-typography {
    display: inline-block;
    color: ${ secondaryFontColor };
    font-size: 20px;
    font-weight: bold;
  }
`;
